import styled from "styled-components";

const SCScore = styled.div`
  padding: 30px 0px;
  letter-spacing: 0.1em;
  h2 {
    margin: 0;
  }
`;

export {
  SCScore
};
